import { injectReducer } from '../../store/reducers'
import { isLoggedIn } from 'utils/auth'

export default (store) => ({
  path: 'analysis/product-demography',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const ProductDemography = require('./containers/ProductDemography').default;
      const productDemographyReducer = require('components/ProductDemography/reducers').default;

      /*  Add the reducer to the store on key 'counter'  */
      // injectReducer(store, { key: 'counter', reducer })
      injectReducer(store, { key: 'productDemographyData', reducer: productDemographyReducer });
      /*  Return getComponent   */
      cb(null, ProductDemography)

    /* Webpack named bundle   */
    }, 'campaign')
  }
})



// WEBPACK FOOTER //
// ./src/routes/ProductDemography/index.js